// 보이는 몸이 기록한 bit 0 안쪽에는 팽창 헐을 그리지 않는다. 추가 draw는 없다.
import * as THREE from 'three/webgpu';

export function maskKaelOutline(body: THREE.Material, hull: THREE.Material): void {
  body.stencilWrite = true;
  body.stencilRef = 1;
  body.stencilFuncMask = 1;
  body.stencilWriteMask = 1;
  body.stencilFunc = THREE.AlwaysStencilFunc;
  body.stencilFail = body.stencilZFail = THREE.KeepStencilOp;
  body.stencilZPass = THREE.ReplaceStencilOp;
  hull.stencilWrite = true;
  hull.stencilRef = 1;
  hull.stencilFuncMask = 1;
  hull.stencilWriteMask = 0;
  hull.stencilFunc = THREE.NotEqualStencilFunc;
  hull.stencilFail = hull.stencilZFail = hull.stencilZPass = THREE.KeepStencilOp;
}

/** scenePass가 매 프레임 지우는 깊이·스텐실 attachment. WebGL2/WebGPU 공통 포맷. */
export function kaelDepthStencil(): THREE.DepthTexture {
  const depth = new THREE.DepthTexture(1, 1, THREE.UnsignedInt248Type);
  depth.format = THREE.DepthStencilFormat;
  return depth;
}
